import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { UserListInterface } from '../types/user-list';
import { UserListFilter } from '../types/user-list-filter';

export const fetchUserList = createAction(
  '[User List] User List Fetch',
  props<{ filter?: UserListFilter }>()
);

export const updateUserListFilter = createAction(
  '[User Filter] User List update filter',
  props<{ filter?: UserListFilter }>()
);

export const loadedUserList = createAction(
  '[User List] User List Loaded',
  props<{ dataSource: DataSource<UserListInterface[]> }>()
);

export const failedUserList = createAction('[User List] User List Failed');

export const deleteUser = createAction(
  '[User List] Delete User',
  props<{ user_id: string }>()
);

export const resetUserList = createAction('[User List] Reset User List');
